module.exports = __webpack_public_path__ + "static/media/tds.c4c76b08.png";